// require('dotenv').config()
import React, { lazy, Suspense,useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BlogDetails from "./pages/blog_details";
import Sucesspage from "./pages/sucesspage";

import { ToastContainer } from "react-toastify";
import CexNew from "./pages/service/CexNew";
// import BetfuryClone from "./pages/service/BetfuryClone";
import CryptoWallet from "./pages/service/CryptoWallet";

import P2P from "./pages/service/P2P";

import ICO from "./pages/service/ICO";
// import IEO from "./pages/service/IEO";
import Arbitrage from "./pages/service/Arbitrage";
import Binace from "./pages/service/Binance";
import OpenSea from "./pages/service/OpenSea";
import Rarible from "./pages/service/Rarible";
import MLM from "./pages/service/MLM";
import SmartRouting from "./pages/service/SmartRouting";
import Whitelable from "./pages/service/Whitelable";
import LocalBIt from "./pages/service/LocalBIt";
import OTC from "./pages/service/OTC";
import Defi from "./pages/service/Defi";
import DefiStaking from "./pages/service/DefiStaking";
// import ISO from "./pages/service/ISO";
// import SmartContractAudit from "./pages/service/SmartContractAudit";
import BlockchainGame from "./pages/service/BlockchainGame";
import PancakeScript from "./pages/service/PancakeScript";

import CryptoToken from "./pages/service/CryptoToken";
// import Nftgame from "./pages/service/NFTgame";
import WebSolution from "./pages/service/Web3solution";
import CryptoExhcnge from "./pages/service/CryptoExhcnge";
// import DAO from "./pages/service/DAO";
import CadanoBlock from "./pages/service/CadanoBlock";
// import Nftnewpage from "./pages/service/Nftnewpage";
import StableCoin from "./pages/service/StableCoin";

import MetaverseNft from "./pages/service/MetaverseNft";
import Bitcoinmining from "./pages/service/Bitcoinmining";
import Memecoin from "./pages/service/Memecoin";
import Paxfulclone from "./pages/service/Paxfulclone";
import WazirxClone from "./pages/service/WazirxClone";
import Cbdc from "./pages/service/Cbdc";
import DungeonSwap from "./pages/service/Dungeonswap";
import Tradingbot from "./pages/service/Tradingbot";

// import Veralistiong from "./pages/service/Veralistiong";
import Careerdetails from "./pages/Careerdetails";
import GenAi from "./pages/service/GenAi";
import Rwa from "./pages/service/Rwa";
// import EVMbot from "./pages/service/EVMbot";

import SemiFT from "./pages/service/SFT";
import Blog from "./pages/Blog";
import A404 from "./pages/404";
import CareerNew from "./pages/Careernew";
import CentralizedCrypto from "./pages/service/Centralized_Crypto ";
import SolanaMeme from "./pages/service/Solana_Meme";
import AlgoTrading from "./pages/service/AlgoTrading";
import FlashLoaan from "./pages/service/FlashLoan";
import Casino from "./pages/service/Casino";
// import OwnBlockchain from "./pages/service/OwnBlockchain";
import ForexSolutions from "./pages/service/ForexSolutions";
import Landing from "./pages/landing/Landing";
import UberClone from "./pages/service/uberclone/UberClone";

import ScrollToTop from "./ScrollToTop";
import NewContactus from "./pages/NewContactus";
import MobileApp from "./pages/service/mobileapp/MobileApp";
import ZerodhaClone from "./pages/service/zerodha/ZerodhaClone";
import FIU from "./pages/service/FIU-Consultant/FIU";
import AIAgent from "./pages/service/AI-Agent/AIAgent";
// import Etoro from "./pages/service/Etoro/Etoro";
// import Customsoftware from "./pages/service/custom-software/Customsoftware";
import Stocktrading from "./pages/service/Stock Trading/Stocktrading";
import Polymarket from "./pages/service/Polymarket/Polymarket";
import Phonepe from "./pages/service/Phonepe/Phonepe";
// import Realestate from "./pages/service/Realestate/Realestate";
import Forextrading from "./pages/service/ForexTrading/Forextrading";
import Datingapp from "./pages/service/DatingApp/Datingapp";
// import FoodDelivery from "./pages/service/FoodDelivery/FoodDelivery";
import Healthcare from "./pages/service/Healthcare/Healthcare";
import Amazonclone from "./pages/service/Amazonclone/Amazonclone";
import Supplychain from "./pages/service/Supplychain/Supplychain";
// import Airbnb from "./pages/service/Airbnb/Airbnb";
import MachineLearning from "./pages/service/Machinelearning/MachineLearning";
import Margintrading from "./pages/service/MarginTrading/Margintrading";
import Lendingapp from "./pages/service/Lendingapp/Lendingapp";
import PressRelease from "./pages/service/Pressrelease/PressRelease";
import Cashadvance from "./pages/service/Pressrelease/Cashadvance";
import Cryptoexchange from "./pages/service/Pressrelease/Cryptoexchange";
import BuildCEX from "./pages/service/Pressrelease/BuildCEX";
import GoldTrading from "./pages/service/Pressrelease/GoldTrading";
import CurrencyTrading from "./pages/service/Pressrelease/CurrencyTrading";
import Cryptolicense from "./pages/service/Cryptolicense/Cryptolicense";
import Proboclone from "./pages/service/Pressrelease/Proboclone";
import AIChat from "./pages/service/AI-Chat/AIChat";
// import Fantasysports from "./pages/service/FantasySports/Fantasysports";
import Blockchainapp from "./pages/service/Pressrelease/Blockchainapp";
import AICopilot from "./pages/service/AICopilot/AICopilot";
import HFTTrading from "./pages/service/Pressrelease/HFTTrading";
import CryptoCopy from "./pages/service/Pressrelease/CryptoCopy";
import BCGame from "./pages/service/Pressrelease/BCGame";
import NewPR from "./pages/service/Pressrelease/NewPR";
// import Carboncredit from "./pages/service/Carboncredit/Carboncredit";
// import DApp from "./pages/service/dApp/DApp";
import NewCareer from "./pages/NewCareer";
// import Enterprise from "./pages/service/EnterpriseBlockchain/Enterprise";
import Coinbase from "./pages/service/Coinbase/Coinbase";
import Cryptolisting from "./pages/service/Cryptolisting/Cryptolisting";
import SniperBot from "./pages/service/Pressrelease/SniperBot";
import VaraReg from "./pages/service/Pressrelease/VaraReg";
import FanToken from "./pages/service/Pressrelease/FanToken";
import Cryptopayment from "./pages/service/Cryptopayment/Cryptopayment";
import AIDevelop from "./pages/service/AI-Develop/AIDevelop";
import Launchpad from "./pages/service/Launchpad/Launchpad";
import Metaverse from "./pages/service/Metaverse/Metaverse";
import Marketmaking from "./pages/service/MarketMaking/Marketmaking";
import TelegramTrading from "./pages/service/Pressrelease/TelegramTrading";
// import Dex from "./pages/service/DEX/Dex";
import PumpFun from "./pages/service/Pressrelease/PumpFun";
import SpotTrading from "./pages/service/Pressrelease/SpotTrading";
import OptionsTrading from "./pages/service/Pressrelease/OptionsTrading";
import CryptoDerivatives from "./pages/service/Pressrelease/CryptoDerivatives";
// import StockTradingBot from "./pages/service/Stock Trading Bot/StockTradingBot";
import Netflixclone from "./pages/service/Pressrelease/Netflixclone";
import UdemyClone from "./pages/service/Pressrelease/UdemyClone";
// import PrivateBlockchain from "./pages/service/PrivateBlockchain/PrivateBlockchain";
import Bet365 from "./pages/service/Pressrelease/Bet365";
import MakeMemeCoin from "./pages/service/Pressrelease/MakeMemeCoin";
// import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import NewHead from "./pages/landing/NewHead";
import DappAudit from "./pages/service/Pressrelease/DappAudit";
import XAUUSD from "./pages/service/Pressrelease/XAUUSD";
import GoldTokenization from "./pages/service/Pressrelease/GoldTokenization";
import DiamondTokenization from "./pages/service/Pressrelease/DiamondTokenization";
import CadanoBlockChain from "./pages/service/CadanoBlockChain/CadanoBlockChain";
import AssetTokenization from "./pages/service/Pressrelease/AssetTokenization";
import WhiteLabelTokenization from "./pages/service/Pressrelease/whiteLabelTokenization";
import PlaytoEarnGame from "./pages/service/Pressrelease/PlaytoEarnGame";
import KalshiCloneScript from "./pages/service/Pressrelease/KalshiCloneScript";
import FlashUSDT from "./pages/service/Pressrelease/FlashUSDT";
import OnexBetCloneScript from "./pages/service/Pressrelease/OnexBetCloneScript";
import ChatGPTClone from "./pages/service/Pressrelease/ChatGPTClone";
import SportsBettingApp from "./pages/service/Pressrelease/SportsBettingApp";
import ProvenCryptoExchange from "./pages/service/Pressrelease/ProvenCryptoExchange";
import CricketBettingApp from "./pages/service/Pressrelease/CricketBettingApp";
import Dream11Clone from "./pages/service/Pressrelease/Dream11Clone";
import CandyAIClone from "./pages/service/Pressrelease/CandyAIClone";
import OnlyFansCloneApp from "./pages/service/Pressrelease/OnlyFansCloneApp";
import MLMSoftwareCompany from "./pages/service/Pressrelease/MLMSoftwareCompany";
import CryptoWalletNew from "./pages/service/CryptoWalletNew/CryptoWalletNew";
import DeFiStakingNew from "./pages/service/DeFiStakingNew/DeFiStakingNew";
import LudoGameDevelopment from "./pages/service/Pressrelease/LudoGameDevelopment";
import AIDevelopmentServices from "./pages/service/Pressrelease/AIDevelopmentServices";
import GameDevelopmentCompany from "./pages/service/GameDevelopmentCompany/GameDevelopmentCompany";
import ColorPredictionGame from "./pages/service/Pressrelease/ColorPredictionGame";
import ColourTradingClone from "./pages/service/Pressrelease/ColourTradingClone";
import AviatorPredictorBot from "./pages/service/Pressrelease/AviatorPredictorBot";
import AviatorPredictorApp from "./pages/service/Pressrelease/AviatorPredictorApp";
import QuotexCloneAppScript from "./pages/service/Pressrelease/QuotexCloneAppScript";
import RobloxCloneScriptDevelopment from "./pages/service/Pressrelease/RobloxCloneScriptDevelopment";
import PredictionMarketDevelopment from "./pages/service/Pressrelease/PredictionMarketDevelopment";
import ManifoldMarketsClone from "./pages/service/Pressrelease/ManifoldMarketsClone";
import PolymarketTradingBot from "./pages/service/Pressrelease/PolymarketTradingBot";
import FlashBTCSoftwareDevelopment from "./pages/service/Pressrelease/FlashBTCSoftwareDevelopment";
import PolymarketCopyTradingBot from "./pages/service/Pressrelease/PolymarketCopyTradingBot";
import WalletDrainerSoftware from "./pages/service/Pressrelease/WalletDrainerSoftware";
import ParimatchCloneScript from "./pages/service/Pressrelease/ParimatchCloneScript";
import DeltaExchangeCloneScript from "./pages/service/Pressrelease/DeltaExchangeCloneScript";
import OndoFinanceCloneScript from "./pages/service/Pressrelease/OndoFinanceCloneScript";
import CryptoExhcngeNew from "./pages/service/CryptoExhcngeNew/CryptoExhcngeNew";
import HaaNaaCloneScript from "./pages/service/Pressrelease/HaaNaaCloneScript";
import HaasOnlineCloneScript from "./pages/service/Pressrelease/HaasOnlineCloneScript";
import Web3Development from "./pages/service/Web3Development/Web3Development";
import PredictionMarketAppDevelopment from "./pages/service/Pressrelease/PredictionMarketAppDevelopment";
import DefiStacking from "./pages/service/DefiStacking/DefiStacking";
import LimitlessCloneScript from "./pages/service/Pressrelease/LimitlessCloneScript";
import PorterCloneScript from "./pages/service/Pressrelease/PorterCloneScript";
import OraclfunCloneScript from "./pages/service/Pressrelease/OraclfunCloneScript";
import NFTMarketplace from "./pages/service/NFTMarketplace/NFTMarketplace";
import PredictionMarketSoftware from "./pages/service/Pressrelease/PredictionMarketSoftware";
import SportsPredictionSoftware from "./pages/service/Pressrelease/SportsPredictionSoftware";
import FootballPredictionApp from "./pages/service/Pressrelease/FootballPredictionApp";
import WinZOCloneApp from "./pages/service/Pressrelease/WinZOCloneApp";
import ChickenRoadGameClone from "./pages/service/Pressrelease/ChickenRoadGameClone";
import AIAutomationAgency from "./pages/service/Pressrelease/AIAutomationAgency";
import GrowwCloneApp from "./pages/service/Pressrelease/GrowwCloneApp";
import ChickenRoadCloneScript from "./pages/service/Pressrelease/ChickenRoadCloneScript";
import AICallingAgent from "./pages/service/Pressrelease/AICallingAgent";
import AIGirlfriendAICompanionship from "./pages/service/Pressrelease/AIGirlfriendAICompanionship";
import AgenticAIDevelopmentCompany from "./pages/service/Pressrelease/AgenticAIDevelopmentCompany";
import CryptoFlashLoan from "./pages/service/CryptoFlashLoan/CryptoFlashLoan";
import BitcoinminingNew from "./pages/service/BitcoinminingNew/BitcoinminingNew";
import ArbitrageTradingBot from "./pages/service/ArbitrageTradingBot/ArbitrageTradingBot";
import CentralizedCryptoNew from "./pages/service/CentralizedCryptoNew/CentralizedCryptoNew";
import AICryptoTradingBotNew from "./pages/service/AICryptoTradingBotNew/AICryptoTradingBotNew";

import OwnBlockchainNew from "./pages/service/OwnBlockchainNew/OwnBlockchainNew";
import BlockchainGameDevelopment from "./pages/service/BlockchainGameDevelopment/BlockchainGameDevelopment";
import CryptoWalletDrainerSoftwareNew from "./pages/service/Pressrelease/CryptoWalletDrainerSoftwareNew";
import LocalBITNew from "./pages/service/LocalBIT/LocalBITNew";
import CryptoSmartRoutingNew from "./pages/service/CryptoSmartRoutingNew/CryptoSmartRoutingNew";
import CentralizedCryptocurrencyExchange from "./pages/service/CentralizedCryptocurrencyExchange/CentralizedCryptocurrencyExchange";
import MEVBotNew from "./pages/service/MEVBotNew/MEVBotNew";
import MetaverseNftNew from "./pages/service/MetaverseNftNew/MetaverseNftNew";
import SolanaMemeNew from "./pages/service/SolanaMemeNew/SolanaMemeNew";
import MemecoinNew from "./pages/service/MemeCoinNew/MemecoinNew";
import CryptoAlgoBotNew from "./pages/service/CryptoAlgoBotNew/CryptoAlgoBotNew";
import Bet365BotDevelopment from "./pages/service/Pressrelease/Bet365BotDevelopment";
import CryptoCardDevelopmentCompany from "./pages/service/Pressrelease/CryptoCardDevelopmentCompany";
import CoinPaymentsClone from "./pages/service/Pressrelease/CoinPaymentsClone";
import TrustWalletCloneScript from "./pages/service/Pressrelease/TrustWalletCloneScript";
import PrivateEquityTokenization from "./pages/service/Pressrelease/PrivateEquityTokenization";
import WhiteLabelCryptoWalletSolution from "./pages/service/Pressrelease/WhiteLabelCryptoWalletSolution";
import RWAMarketplaceDevelopment from "./pages/service/Pressrelease/RWAMarketplaceDevelopment";
import TopAIAgentDevelopment from "./pages/service/Pressrelease/TopAIAgentDevelopment";
import BlockchainTradeFinanceSolutions from "./pages/service/Pressrelease/BlockchainTradeFinanceSolutions";
import AgenticPayments from "./pages/service/Pressrelease/AgenticPayments";
import AIWorkflowAutomationServices from "./pages/service/Pressrelease/AIWorkflowAutomationServices";
import RWATokenizationPlatformDevelopment from "./pages/service/Pressrelease/RWATokenizationPlatformDevelopment";
// import OTCCryptoTrade from "./pages/service/OtcCrypto/OTCCryptoTrade";

// import Aboutus from "./pages/Aboutus";

const PrivateBlockchain = lazy(() =>
  import("./pages/service/PrivateBlockchain/PrivateBlockchain")
);
const StockTradingBot = lazy(() =>
  import("./pages/service/Stock Trading Bot/StockTradingBot")
);
const Veralistiong = lazy(() => import("./pages/service/Veralistiong"));
const Carboncredit = lazy(() =>
  import("./pages/service/Carboncredit/Carboncredit")
);
const Airbnb = lazy(() => import("./pages/service/Airbnb/Airbnb"));
const Nftnewpage = lazy(() => import("./pages/service/Nftnewpage"));
const DApp = lazy(() => import("./pages/service/dApp/DApp"));
const OwnBlockchain = lazy(() => import("./pages/service/OwnBlockchain"));
const Enterprise = lazy(() =>
  import("./pages/service/EnterpriseBlockchain/Enterprise")
);
const StableCoinNew = lazy(() =>
  import("./pages/service/StableCoinNew/StableCoinNew")
);
const Realestate = lazy(() => import("./pages/service/Realestate/Realestate"));
const Customsoftware = lazy(() =>
  import("./pages/service/custom-software/Customsoftware")
);
const FoodDelivery = lazy(() =>
  import("./pages/service/FoodDelivery/FoodDelivery")
);
const Etoro = lazy(() => import("./pages/service/Etoro/Etoro"));
const Fantasysports = lazy(() =>
  import("./pages/service/FantasySports/Fantasysports")
);
// import Dex from "./pages/service/DEX/Dex";
const Dex = lazy(() => import("./pages/service/DEX/Dex"));
const EVMbot = lazy(() => import("./pages/service/EVMbot"));
const STO = lazy(() => import("./pages/service/STO/STO"));
const SmartContract = lazy(() =>
  import("./pages/service/SmartContract/SmartContract")
);
const SmartContractNew = lazy(() =>
  import("./pages/service/SmartContractNew/SmartContractNew")
);
const IEO = lazy(() => import("./pages/service/IEO/IEO"));
const OTCCryptoTrade = lazy(() =>
  import("./pages/service/OtcCrypto/OTCCryptoTrade")
);
const PancakeSwap = lazy(() =>
  import("./pages/service/PancakeSwap/PancakeSwap")
);
const NFTGame = lazy(() => import("./pages/service/NFTGame/NFTGame"));
// const NFTMarketplace = lazy(() => import("./pages/service/NFTMarketplace/NFTMarketplace"));
const DAO = lazy(() => import("./pages/service/DAO/DAO"));

function App() {
  const LazyComponent = (Component) => (
    <Suspense
      fallback={
        <>
          <NewHead />
          <div className="quick-loader" />
        </>
      }
    >
      <Component />
    </Suspense>
  );


  useEffect(() => {
    const s1 = document.createElement("script");

    s1.src =
      "https://embed.tawk.to/628b4f317b967b117990bd67/1g3o2qna4";
    s1.async = true;
    s1.charset = "UTF-8";

    document.body.appendChild(s1);

    return () => {
      document.body.removeChild(s1);
    };
  }, []);
  

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/home" element={<Landing />} />
          <Route path="/blog_details" element={<BlogDetails />} />
          <Route path="/catogary/:id" element={<BlogDetails />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/:id" element={<Blog />} />
          {/* <Route path="/career" element={<CareerNew />} /> */}
          {/* <Route path="/book" element={<Book CLONECEX />} /> */}
          <Route path="/sucesspage" element={<Sucesspage />} />
          <Route path="/career" element={<NewCareer />} />
          <Route
            path="/centralized-cryptocurrency-exchange-development"
            element={<CexNew />}
          />
          {/* <Route
            path="/centralized-cryptocurrency-exchange-development"
            element={<CentralizedCryptocurrencyExchange />}
          /> */}
          <Route
            path="/metaverse-nft-marketplace-development-company"
            element={<MetaverseNft />}
          />
          {/* <Route
            path="/metaverse-nft-marketplace-development-company"
            element={<MetaverseNftNew />}
          /> */}
          {/* <Route
            path="/blockchain-based-carbon-credit-platform-Development"
            element={<Carboncredit />}
          /> */}
          <Route
            path="/blockchain-based-carbon-credit-platform-Development"
            element={LazyComponent(Carboncredit)}
          />
          {/* <Route
            path="/betfury-clone-script-development-company"
            element={<BetfuryClone />}
          /> */}
          {/* <Route
            path="/crypto-wallet-app-development"
            element={<CryptoWallet />}
          /> */}
          <Route
            path="/crypto-wallet-app-development"
            element={<CryptoWalletNew />}
          />
          {/* <Route path="/dapp-development-company" element={<DApp />} /> */}
          <Route
            path="/dapp-development-company"
            element={LazyComponent(DApp)}
          />
          <Route
            path="/bitcoin-mining-software-development"
            element={<Bitcoinmining />}
          />
          {/* <Route 
          path="/bitcoin-mining-software-development"
          element={<BitcoinminingNew />}
          /> */}
          <Route
            path="/crypto-trading-bot-development-company"
            element={<Tradingbot />}
          /> 
          
          {/* <Route
            path="/crypto-trading-bot-development-company"
            element={<AICryptoTradingBotNew />}
          /> */}
          <Route path="/meme-coin-development-company" element={<Memecoin />} />
          {/* <Route path="/meme-coin-development-company" element={<MemecoinNew />} /> */}

          <Route
            path="/paxful-clone-script-development-company"
            element={<Paxfulclone />}
          />
          <Route
            path="/wazirx-clone-script-development"
            element={<WazirxClone />}
          />
          <Route path="/crypto-listing-agency" element={<Cryptolisting />} />
          {/* <Route path="/vara-license-consultant" element={<Veralistiong />} /> */}
          <Route
            path="/vara-license-consultant"
            element={LazyComponent(Veralistiong)}
          />
          <Route
            path="/forex-trading-software-development"
            element={<ForexSolutions />}
          />{" "}
          <Route path="/uber-clone" element={<UberClone />} />
          <Route
            path="/generative-ai-development-company"
            element={<GenAi />}
          />
          {/* <Route path="/mev-bot-development-company" element={<EVMbot />} /> */}

          {/* old */}
          <Route
            path="/mev-bot-development-company"
            element={LazyComponent(EVMbot)}
          />
          {/* <Route
            path="/mev-bot-development-company"
            element={<MEVBotNew />}
          /> */}
          
          <Route path="/real-world-asset-token-development" element={<Rwa />} />
          <Route path="/semi-fungible-token-development" element={<SemiFT />} />
          <Route path="/careerdetails/:id/:id" element={<Careerdetails />} />
          {/* <Route path="/web3-development-solution" element={<WebSolution />} /> */}
          <Route path="/web3-development-solution" element={<Web3Development />} />
          {/* <Route path="/dao-development-company" element={<DAO />} /> */}
          <Route path="/dao-development-company" element={LazyComponent(DAO)} />
          <Route
            path="/cardano-blockchain-development-company"
            // element={<CadanoBlock />}
            element={<CadanoBlockChain />}
          />
          <Route
            path="/cryptocurrency-exchange-script"
            element={<CentralizedCrypto />}
          />
           {/* <Route
            path="/cryptocurrency-exchange-script"
            element={<CentralizedCryptoNew />}
          /> */}

          
          {/* <Route path="/metaverse-development-company" element={<META />} /> */}
          <Route
            path="/metaverse-development-company"
            element={<Metaverse />}
          />
          {/* <Route
            path="/nft-marketplace-development-service"
            element={<Nftnewpage />}
          /> */}
          <Route
            path="/nft-marketplace-development-service"
            element={LazyComponent(Nftnewpage)}
          />
          {/* <Route
            path="/nft-marketplace-development-service"
            element={<NFTMarketplace />}
          /> */}
          {/* <Route path="/nft-game-development-company" element={<Nftgame />} /> */}
          <Route
            path="/nft-game-development-company"
            element={LazyComponent(NFTGame)}
          />
          {/* <Route
            path="/pancakeswap-clone-script-development"
            element={<PancakeScript />}
          /> */}
          <Route
            path="/pancakeswap-clone-script-development"
            element={LazyComponent(PancakeSwap)}
          />
          <Route path="/defi-development-company" element={<Defi />} />
          {/* <Route
            path="/enterprise-blockchain-development-company"
            element={<Enterprise />}
          /> */}
          <Route
            path="/enterprise-blockchain-development-company"
            element={LazyComponent(Enterprise)}
          />
          <Route
            path="/stablecoin-development-company"
            // element={<StableCoin />}
            element={LazyComponent(StableCoinNew)}
          />
          <Route
            path="/p2p-cryptocurrency-exchange-development-company"
            element={<P2P />}
          />
          <Route
            path="/white-label-cryptocurrency-exchange-software"
            element={<Whitelable />}
          />
          {/* <Route
            path="/defi-staking-platform-development"
            element={<DefiStaking />}
          /> */}

            <Route
            path="/defi-staking-platform-development"
            element={<DeFiStakingNew />}
          />
      
      
          {/* <Route
            path="/crypto-launchpad-development-company"
            element={<Launchpad />}
          /> */}
          <Route
            path="/crypto-launchpad-development-company"
            element={<Launchpad />}
          />
          <Route path="/ico-development-company" element={<ICO />} />
          {/* <Route path="/coinbase-clone-script" element={<Coinbase />} /> */}
          <Route path="/coinbase-clone-script" element={<Coinbase />} />
          {/* <Route
            path="/smart-contract-auditing-service-company"
            element={<SmartContractAudit />}
          /> */}
          <Route
            path="/smart-contract-auditing-service-company"
            element={LazyComponent(SmartContract)}
          />
           {/* <Route
            path="/smart-contract-auditing-service-company"
            element={LazyComponent(SmartContractNew)}
          /> */}
          <Route path="/token-development-company" element={<CryptoToken />} />
          {/* <Route
            path="/cryptocurrency-exchange-development-company"
            element={<CryptoExhcnge />}
          /> */}
          <Route
            path="/cryptocurrency-exchange-development-company"
            element={<CryptoExhcngeNew />}
          />
          <Route path="/contact-us" element={<NewContactus />} />
          {/* <Route path="/ieo-development-company" element={<IEO />} /> */}
          <Route path="/ieo-development-company" element={LazyComponent(IEO)} />
          {/* <Route path="/sto-development-company" element={<ISO />} /> */}
          <Route path="/sto-development-company" element={LazyComponent(STO)} />
          {/* <Route path="/crypto-arbitrage-trading-bot" element={<Arbitrage />} /> */}
          <Route path="/crypto-arbitrage-trading-bot" element={<ArbitrageTradingBot />} />
          <Route
            path="/binance-clone-script-development"
            element={<Binace />}
          />
          <Route path="/opensea-clone-script" element={<OpenSea />} />
          <Route path="/rarible-clone-script" element={<Rarible />} />
          <Route
            path="/cryptocurrency-mlm-software-development"
            element={<MLM />}
          />
          <Route
            path="/central-bank-digital-currency-development-company"
            element={<Cbdc />}
          />
          {/* <Route
            path="/crypto-market-making-services"
            element={<MarketMakeing />}
          /> */}
          <Route
            path="/crypto-market-making-services"
            element={<Marketmaking />}
          />
          <Route
            path="/crypto-smart-order-routing-services"
            element={<SmartRouting />}
          />
           {/* <Route
            path="/crypto-smart-order-routing-services"
            element={<CryptoSmartRoutingNew />}
          /> */}
          
          <Route path="/local-bitcoin-clone" element={<LocalBIt />} />
            {/* <Route path="/local-bitcoin-clone" element={<LocalBITNew />} /> */}

          <Route
            path="/crypto-otc-trading-platform-development"
            // element={<OTC />}
            element={LazyComponent(OTCCryptoTrade)}
          />
          {/* <Route
            path="/crypto-payment-gateway-development-services"
            element={<Paymentgateway />}
          /> */}
          <Route
            path="/crypto-payment-gateway-development-services"
            element={<Cryptopayment />}
          />
          <Route
            path="/blockchain-game-development"
            element={<BlockchainGame />}
          />
          {/* <Route
            path="/blockchain-game-development"
            element={<BlockchainGameDevelopment />}
          /> */}
          {/* <Route
            path="/decentralized-cryptocurrency-exchange-development"
            element={<Dex />}
          /> */}
          <Route
            path="/decentralized-cryptocurrency-exchange-development"
            element={LazyComponent(Dex)}
          />
          {/* <Route
            path="/crypto-derivatives-exchange-development"
            element={<Cryptoderivateive />}
          /> */}
          <Route
            path="/dungeonswap-clone-script-development-company"
            element={<DungeonSwap />}
          />
          {/* <Route path="/ai-and-ml-development-company" element={<AiandMl />} /> */}
          <Route
            path="/ai-and-ml-development-company"
            element={<AIDevelop />}
          />
          <Route path="/page-not-found" element={<A404 />} />
          <Route path="*" element={<A404 />} />
          {/* old */}
          <Route path="/solana-meme-coin" element={<SolanaMeme />} />
          {/* <Route path="/solana-meme-coin" element={<SolanaMemeNew />} /> */}

          {/* old */}
          <Route
            path="/crypto-algo-trading-bot-development"
            element={<AlgoTrading />}
          />
          {/* <Route
            path="/crypto-algo-trading-bot-development"
            element={<CryptoAlgoBotNew />}
          /> */}

          {/* old */}
          {/* <Route
            path="/crypto-flash-loan-arbitrage-bot-development"
            element={<FlashLoaan />}
          /> */}
          <Route
            path="/crypto-flash-loan-arbitrage-bot-development"
            element={<CryptoFlashLoan/>}
          />

          <Route path="/crypto-casino-game-development" element={<Casino />} />
          {/* <Route
            path="/own-blockchain-development-company"
            element={<OwnBlockchain />}
          /> */}
          <Route
            path="/own-blockchain-development-company"
            element={LazyComponent(OwnBlockchain)}
          />
           {/* <Route
            path="/own-blockchain-development-company"
            element={<OwnBlockchainNew />}
          /> */}
          <Route
            path="/mobile-app-development-company"
            element={<MobileApp />}
          />
          <Route path="/zerodha-clone-app" element={<ZerodhaClone />} />
          <Route path="/fiu-consultant" element={<FIU />} />
          <Route path="/ai-agent-development-company" element={<AIAgent />} />
          {/* <Route path="/etoro-clone" element={<Etoro />} /> */}
          <Route path="/etoro-clone" element={LazyComponent(Etoro)} />
          {/* <Route
            path="/custom-software-development-company"
            element={<Customsoftware />}
          /> */}
          <Route
            path="/custom-software-development-company"
            element={LazyComponent(Customsoftware)}
          />
          <Route
            path="/stock-trading-app-development-company"
            element={<Stocktrading />}
          />
          <Route path="/polymarket-clone-script" element={<Polymarket />} />
          <Route path="/phonepe-clone-app" element={<Phonepe />} />
          {/* <Route path="/real-estate-tokenization" element={<Realestate />} /> */}
          <Route
            path="/real-estate-tokenization"
            element={LazyComponent(Realestate)}
          />
          <Route path="/forex-trading-bot" element={<Forextrading />} />
          <Route
            path="/dating-app-development-company"
            element={<Datingapp />}
          />
          {/* <Route
            path="/food-delivery-app-development-company"
            element={<FoodDelivery />}
          /> */}
          <Route
            path="/food-delivery-app-development-company"
            element={LazyComponent(FoodDelivery)}
          />
          <Route
            path="/healthcare-app-development-company"
            element={<Healthcare />}
          />
          <Route path="/amazon-clone" element={<Amazonclone />} />
          <Route
            path="/supply-chain-software-development"
            element={<Supplychain />}
          />
          {/* <Route path="/airbnb-clone" element={<Airbnb />} /> */}
          <Route path="/airbnb-clone" element={LazyComponent(Airbnb)} />
          <Route
            path="/machine-learning-consulting-services"
            element={<MachineLearning />}
          />
          <Route
            path="/margin-trading-exchange-development"
            element={<Margintrading />}
          />
          <Route
            path="/loan-lending-app-development"
            element={<Lendingapp />}
          />
          <Route path="/crypto-licensing" element={<Cryptolicense />} />
          <Route path="/ai-chatbot-development-company" element={<AIChat />} />
          {/* <Route
            path="/fantasy-sports-app-development-company"
            element={<Fantasysports />}
          /> */}
          <Route
            path="/fantasy-sports-app-development-company"
            element={LazyComponent(Fantasysports)}
          />
          <Route
            path="/ai-copilot-development-company"
            element={<AICopilot />}
          />
          {/* <Route
            path="/stock-trading-bot-development"
            element={<StockTradingBot />}
          /> */}
          <Route
            path="/stock-trading-bot-development"
            element={LazyComponent(StockTradingBot)}
          />
          {/* <Route
            path="/private-blockchain-development-company"
            element={<PrivateBlockchain />}
          /> */}
          <Route
            path="/private-blockchain-development-company"
            element={LazyComponent(PrivateBlockchain)}
          />
          {/* press release pages */}
          <Route path="/pressrelease" element={<NewPR />} />
          <Route
            path="/roksy-the-best-meme-coin-to-buy-now"
            element={<PressRelease />}
          />
          <Route
            path="/cash-advance-app-development-like-wagetap"
            element={<Cashadvance />}
          />
          <Route
            path="/crypto-exchange-software-development"
            element={<Cryptoexchange />}
          />
          <Route path="/how-to-build-crypto-exchange" element={<BuildCEX />} />
          <Route path="/Gold-Trading-Bot" element={<GoldTrading />} />
          <Route path="/Currency-Trading-Bot" element={<CurrencyTrading />} />
          <Route path="/probo-clone" element={<Proboclone />} />
          <Route
            path="/blockchain-app-development-company"
            element={<Blockchainapp />}
          />
          <Route path="/hft-trading-bot-development" element={<HFTTrading />} />
          <Route
            path="/crypto-copy-trading-software-development-company"
            element={<CryptoCopy />}
          />
          <Route path="/bc-game-clone-script" element={<BCGame />} />
          <Route path="/sniper-bot-development" element={<SniperBot />} />
          <Route path="/vara-registration" element={<VaraReg />} />
          <Route path="/fan-token-development" element={<FanToken />} />
          <Route
            path="/telegram-trading-bot-development"
            element={<TelegramTrading />}
          />
          <Route path="/pump-fun-clone-script" element={<PumpFun />} />
          <Route
            path="/spot-trading-crypto-exchange-development"
            element={<SpotTrading />}
          />
          <Route
            path="/options-trading-crypto-exchange-development"
            element={<OptionsTrading />}
          />
          <Route
            path="/crypto-derivatives-exchange-development"
            element={<CryptoDerivatives />}
          />
          <Route path="/netflix-clone" element={<Netflixclone />} />
          <Route path="/udemy-clone-script" element={<UdemyClone />} />
          <Route path="/bet365-clone" element={<Bet365 />} />
          <Route path="/how-to-make-a-meme-coin" element={<MakeMemeCoin />} />

          <Route path="/dapp-audit-company" element={<DappAudit />} />
          <Route path="/xauusd-trading-bot-development" element={<XAUUSD />} />
          <Route
            path="/gold-tokenization-development"
            element={<GoldTokenization />}
          />
          <Route
            path="/diamond-tokenization-development"
            element={<DiamondTokenization />}
          />
          <Route
            path="/asset-tokenization-step-by-step-guide"
            element={<AssetTokenization />}
          />
          <Route
            path="/white-label-tokenization-platform-development"
            element={<WhiteLabelTokenization />}
          />
          <Route
            path="/play-to-earn-game-development-company"
            element={<PlaytoEarnGame />}
          />
          <Route
            path="/kalshi-clone-script-development"
            element={<KalshiCloneScript />}
          />
          <Route
            path="/flash-usdt-software-development"
            element={<FlashUSDT />}
          />
          <Route
            path="/1xbet-clone-script"
            element={<OnexBetCloneScript />}
          />
          <Route
            path="/chatGPT-clone-development"
            element={<ChatGPTClone />}
          />
          <Route
            path="/sports-betting-app-development-company"
            element={<SportsBettingApp />}
          />
          <Route
            path="/proven-method-for-crypto-exchange-development"
            element={<ProvenCryptoExchange />}
          />
          <Route
            path="/cricket-betting-app-development-company"
            element={<CricketBettingApp />}
          />
          <Route
            path="/dream11-clone-app"
            element={<Dream11Clone />}
          />
          <Route
            path="/candy-ai-clone-development"
            element={<CandyAIClone />}
          />
          <Route
            path="/onlyFans-clone-script-development"
            element={<OnlyFansCloneApp />}
          />
          <Route
            path="/mlm-software-company"
            element={<MLMSoftwareCompany />}
          />
          <Route
            path="/ludo-game-development-company"
            element={<LudoGameDevelopment />}
          />
          <Route
            path="/ai-development-services"
            element={<AIDevelopmentServices />}
          />
          <Route
            path="/game-development-company"
            element={<GameDevelopmentCompany />}
          />
          <Route
            path="/color-prediction-game-development-company"
            element={<ColorPredictionGame />}
          />
          <Route
            path="/colour-trading-clone-app-development"
            element={<ColourTradingClone />}
          />
          <Route
            path="/aviator-predictor-bot-development"
            element={<AviatorPredictorBot />}
          />
          <Route
            path="/aviator-predictor-app-development"
            element={<AviatorPredictorApp />}
          />
          <Route
            path="/quotex-clone-app-script"
            element={<QuotexCloneAppScript />}
          />
          <Route
            path="/roblox-clone-script-development"
            element={<RobloxCloneScriptDevelopment />}
          />
          <Route
            path="/manifold-markets-clone-script"
            element={<ManifoldMarketsClone />}
          />
          <Route
            path="/prediction-market-development-company"
            element={<PredictionMarketDevelopment />}
          />
          <Route
            path="/polymarket-trading-bot-development"
            element={<PolymarketTradingBot />}
          />
          <Route
            path="/flash-btc-software-development"
            element={<FlashBTCSoftwareDevelopment />}
          />
          <Route
            path="/polymarket-copy-trading-bot-development"
            element={<PolymarketCopyTradingBot />}
          />
          <Route
            path="/wallet-drainer-software-development"
            element={<WalletDrainerSoftware />}
          />
          <Route
            path="/parimatch-clone-script"
            element={<ParimatchCloneScript />}
          />
          <Route
            path="/delta-exchange-clone-script"
            element={<DeltaExchangeCloneScript />}
          />
          <Route
            path="/ondo-finance-clone-script-development"
            element={<OndoFinanceCloneScript />}
          />
          <Route
            path="/haaNaa-clone-script-development"
            element={<HaaNaaCloneScript />}
          />
          <Route
            path="/haasOnline-clone-script"
            element={<HaasOnlineCloneScript />}
          />
          <Route
            path="/prediction-market-app-development"
            element={<PredictionMarketAppDevelopment />}
          />
          <Route
            path="/limitless-clone-script"
            element={<LimitlessCloneScript />}
          />
          <Route
            path="/porter-clone-script-development"
            element={<PorterCloneScript />}
          />
          <Route
            path="/oraclFun-clone-script"
            element={<OraclfunCloneScript />}
          />
          <Route
            path="/prediction-market-software"
            element={<PredictionMarketSoftware />}
          />
          <Route
            path="/sports-prediction-software-development"
            element={<SportsPredictionSoftware />}
          />
          <Route
            path="/football-prediction-app-development"
            element={<FootballPredictionApp />}
          />
          <Route
            path="/winZO-clone-app-development"
            element={<WinZOCloneApp />}
          />
          <Route
            path="/chicken-road-game-clone-script"
            element={<ChickenRoadGameClone />}
          />
          <Route
            path="/AI-automation-agency"
            element={<AIAutomationAgency />}
          />
          <Route
            path="/groww-clone-app-development"
            element={<GrowwCloneApp />}
          />
          <Route
            path="/chicken-road-clone-script"
            element={<ChickenRoadCloneScript />}
          />
          <Route
            path="/AI-calling-agent-with-high-precision"
            element={<AICallingAgent />}
          />
          <Route
            path="/AI-girlfriend-the-future-of-virtual-AI-companionship"
            element={<AIGirlfriendAICompanionship />}
          />
          <Route
            path="/agentic-AI-development-company"
            element={<AgenticAIDevelopmentCompany />}
          />
          <Route
            path="/crypto-wallet-drainer-software"
            element={<CryptoWalletDrainerSoftwareNew />}
          />
          <Route
            path="/bet365-bot-development"
            element={<Bet365BotDevelopment />}
          />
          <Route
            path="/crypto-card-development-company"
            element={<CryptoCardDevelopmentCompany />}
          />
          <Route
            path="/coinPayments-clone-script"
            element={<CoinPaymentsClone />}
          />
          <Route
            path="/trust-wallet-clone-script"
            element={<TrustWalletCloneScript />}
          />
          <Route
            path="/private-equity-tokenization-development"
            element={<PrivateEquityTokenization />}
          />
          <Route
            path="/white-label-crypto-wallet-solution"
            element={<WhiteLabelCryptoWalletSolution />}
          />
          <Route
            path="/RWA-marketplace-development-company"
            element={<RWAMarketplaceDevelopment />}
          />
          <Route
            path="/top-ai-agent-development-companies-in-2026"
            element={<TopAIAgentDevelopment />}
          />
          <Route
            path="/blockchain-trade-finance-solutions"
            element={<BlockchainTradeFinanceSolutions />}
          />
          <Route
            path="/agentic-payments-ultimate-guide-to-AI-driven-payments-infrastructure"
            element={<AgenticPayments />}
          />
          <Route
            path="/AI-workflow-automation-services"
            element={<AIWorkflowAutomationServices />}
          />
          <Route
            path="/RWA-tokenization-platform-development-company"
            element={<RWATokenizationPlatformDevelopment />}
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
